import { render, staticRenderFns } from "./organization-archived-tasks.vue?vue&type=template&id=306bc2f5"
import script from "./organization-archived-tasks.vue?vue&type=script&lang=js"
export * from "./organization-archived-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports